import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import {
  BUTTON_THEME_GREEN_ADOBE,
  BUTTON_THEME_GREY_ADOBE,
} from 'client/components/ButtonDeprecated';

import './SrOfflinePaymentReceivedModal.less';

const SrOfflinePaymentReceivedModal = ({ onClickReceivedPayment, onClose, paymentConfirmed }) => {
  if (paymentConfirmed) {
    return (
      <SrSimpleMessageModal
        theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
        iconUrl="/images/checkmark-circle-large-green.svg"
        headline="Offline Payment Confirmed!"
        maxWidth={375}
      />
    );
  }

  return (
    <SrSimpleMessageModal
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      iconUrl="/images/question-mark-circle-green.svg"
      headline="Have you received the renter payment offline?"
      underline
      message={
        <SrText
          font="greycliff"
          weight="600"
          color="grey"
          display="block"
          align="center"
          paddingRight="12px"
          paddingLeft="12px"
          lineHeight="25px"
        >
          After confirming, we'll send the lease for signing.
        </SrText>
      }
      maxWidth={375}
      multiButtons={[
        {
          buttonText: "I've Received the Payment",
          buttonTheme: BUTTON_THEME_GREEN_ADOBE,
          onButtonClick: onClickReceivedPayment,
        },
        {
          buttonText: 'Close',
          buttonTheme: BUTTON_THEME_GREY_ADOBE,
          onButtonClick: onClose,
        },
      ]}
      onClose={onClose}
    />
  );
};

SrOfflinePaymentReceivedModal.propTypes = {
  onClickReceivedPayment: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  paymentConfirmed: PropTypes.bool.isRequired,
};

SrOfflinePaymentReceivedModal.displayName = 'SrOfflinePaymentReceivedModal';

export default SrOfflinePaymentReceivedModal;
